import React, { useState, useEffect } from "react";
import axios from "axios";

const InvestigationList = ({ invdeptid }) => {
    const [investigations, setInvestigations] = useState([]);
    const [filteredInvestigations, setFilteredInvestigations] = useState([]);
    const [invdeptname, setDepartmentName] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 25; // Show 25 investigations per page

    useEffect(() => {
        if (invdeptid) {
            setCurrentPage(1);
            setSearchQuery('');
            // Fetch investigations for the selected department
            axios.get(`https://ndcapp.in/webapi/invdepts/invdeptlist1db.php?action=investigations&invdeptid=${invdeptid}`)
                .then(response => setInvestigations(response.data))
                .catch(error => console.error("Error fetching investigations", error));

                 // Fetch department name
            axios.get(`https://ndcapp.in/webapi/invdepts/invdeptlist1db.php?action=departments`)
            .then(response => {
                const dept = response.data.find(d => d.invdeptid === invdeptid);
                setDepartmentName(dept ? dept.invdeptname : "Unknown Department");
            })
            .catch(error => console.error("Error fetching department name", error));



        }
    }, [invdeptid]);

    // Handle Search
    useEffect(() => {
        if (searchQuery) {
            const filtered = investigations.filter(inv =>
                inv.investigationsname.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredInvestigations(filtered);
            setCurrentPage(1); // Reset pagination when searching
        } else {
            setFilteredInvestigations(investigations);
        }
    }, [searchQuery, investigations]);


    // Pagination Logic
    const totalPages = Math.ceil(filteredInvestigations.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentInvestigations = filteredInvestigations.slice(indexOfFirstItem, indexOfLastItem);

    // Generate Pagination Numbers with Ellipsis
    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5; // Total numbers visible including ellipsis

        if (totalPages <= maxPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage > 3) pages.push(1, "...");

            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (currentPage < totalPages - 2) pages.push("...", totalPages);
        }

        return pages;
    };

    return (
        <div className="container mt-3">
              <h3 className="text-primary">
                {invdeptid ? `Investigations - ${invdeptname}` : "Select a Department"}
            </h3>
            {invdeptid ? (
                <>

                {/* Search Input */}
                <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search Investigations..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                <div className="dataTable_wrapper">
                    <table className="table table-hover table-striped table-bordered" >
                        <thead className="thead-dark">
                            <tr>
                                <th>Investigation Name</th>
                                <th>Charge (INR)</th>
                            </tr>
                        </thead>
                        <tbody>
               
                        {currentInvestigations.length > 0 ? (
                                    currentInvestigations.map((inv, index) => (
                        <tr key={inv.investigationid}>
                            <td>{inv.investigationsname}</td>
                            <td>{inv.opdcharge} </td>
                        </tr>
                     ))
                    ) : (
                        <tr>
                            <td colSpan="2" className="text-center">No investigations found</td>
                        </tr>
                    )}
               
                        </tbody>
                </table>
                </div>

                 {/* Pagination Controls */}
                 <nav>
                        <ul className="pagination justify-content-center">
                            {/* First Page Button */}
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(1)}>«</button>
                            </li>

                            {/* Previous Button */}
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                            </li>

                            {/* Page Numbers with Ellipsis */}
                            {getPageNumbers().map((page, index) =>
                                page === "..." ? (
                                    <li key={index} className="page-item disabled">
                                        <span className="page-link">...</span>
                                    </li>
                                ) : (
                                    <li key={index} className={`page-item ${currentPage === page ? "active" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(page)}>
                                            {page}
                                        </button>
                                    </li>
                                )
                            )}

                            {/* Next Button */}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                            </li>

                            {/* Last Page Button */}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(totalPages)}>»</button>
                            </li>
                        </ul>
                    </nav>
                </>
            ) : (
                <p>Select a department to view investigations</p>
            )}
        </div>
    );
};

export default InvestigationList;
